import { Routes } from "@angular/router";
import { AuthGuard } from "./auth/auth.guard";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";
import { LoginComponent } from "./auth/login/login.component";
import { PasswordRecoverComponent } from "./auth/password-recover/password-recover.component";
import { PageComponent } from "./cmspage/page/page.component";
import { ContactFormComponent } from "./cmspage/contact-form/contact-form.component";
import { AdminComponent } from "./admin/admin/admin.component";
import { AdminDashboardComponent } from "./admin/admin-dashboard/admin-dashboard.component";
import { SettingsComponent } from "./admin/settings/settings.component";
import { ManageStartupsComponent } from "./admin/startups/manage-startups/manage-startups.component";
import { StartupsFormComponent } from "./admin/startups/startups-form/startups-form.component";
import { ManageFoundersComponent } from "./admin/founders/manage-founders/manage-founders.component";
import { FoundersFormComponent } from "./admin/founders/founders-form/founders-form.component";
import { ManageNewsComponent } from "./admin/news/manage-news/manage-news.component";
import { NewsFormComponent } from "./admin/news/news-form/news-form.component";
import { ManagePagesComponent } from "./admin/pages/manage-pages/manage-pages.component";
import { PagesFormComponent } from "./admin/pages/pages-form/pages-form.component";
import { ManageUsersComponent } from "./admin/users/manage-users/manage-users.component";
import { UsersFormComponent } from "./admin/users/users-form/users-form.component";
import { ManageCategoriesComponent } from "./admin/settings/categories/manage-categories/manage-categories.component";
import { CategoriesFormComponent } from "./admin/settings/categories/categories-form/categories-form.component";
import { ManageTagsComponent } from "./admin/settings/tags/manage-tags/manage-tags.component";
import { TagsFormComponent } from "./admin/settings/tags/tags-form/tags-form.component";
import { ManageReviewsComponent } from "./admin/reviews/manage-reviews/manage-reviews.component";
import { ReviewsFormComponent } from "./admin/reviews/reviews-form/reviews-form.component";
import { ManageTrustpilotComponent } from "./admin/settings/trustpilot/manage-trustpilot/manage-trustpilot.component";
import { TrustpilotFormComponent } from "./admin/settings/trustpilot/trustpilot-form/trustpilot-form.component";
import { ManageLikesComponent } from "./admin/likes/manage-likes/manage-likes.component";
import { LikesFormComponent } from "./admin/likes/likes-form/likes-form.component";
import { ManageTechnologyComponent } from "./admin/settings/technology/manage-technology/manage-technology.component";
import { TechnologyFormComponent } from "./admin/settings/technology/technology-form/technology-form.component";
import { ManageTicketsComponent } from "./admin/tickets/manage-tickets/manage-tickets.component";
import { TicketDetailComponent } from "./admin/tickets/ticket-detail/ticket-detail.component";
import { ProductFormComponent } from "./products/product-form/product-form.component";
import { AdsManagerComponent } from "./admin/ads-manager/ads-manager.component";

export const routes: Routes = [
  // Auth routes
  { path: "login", component: LoginComponent },
  { path: "password-recover", component: PasswordRecoverComponent },

  // CMS routes
  { path: "page/:slug", component: PageComponent },
  { path: "contact", component: ContactFormComponent },
  { path: "products/new", component: ProductFormComponent },
  { path: "products/:id", component: ProductFormComponent },

  // Admin routes
  {
    path: "admin",
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        children: [
          { path: "settings", component: SettingsComponent },

          { path: "settings/categories", component: ManageCategoriesComponent },
          {
            path: "settings/categories/edit/:id",
            component: CategoriesFormComponent,
          },
          {
            path: "settings/categories/create",
            component: CategoriesFormComponent,
          },

          { path: "settings/tags", component: ManageTagsComponent },
          { path: "settings/tags/edit/:id", component: TagsFormComponent },
          { path: "settings/tags/create", component: TagsFormComponent },

          { path: "settings/technology", component: ManageTechnologyComponent },
          {
            path: "settings/technology/edit/:id",
            component: TechnologyFormComponent,
          },
          {
            path: "settings/technology/create",
            component: TechnologyFormComponent,
          },

          { path: "reviews", component: ManageReviewsComponent },
          { path: "reviews/create", component: ReviewsFormComponent },
          { path: "reviews/edit/:id", component: ReviewsFormComponent },

          { path: "likes", component: ManageLikesComponent },
          { path: "likes/create", component: LikesFormComponent },
          { path: "likes/edit/:id", component: LikesFormComponent },

          { path: "tickets", component: ManageTicketsComponent },
          { path: "tickets/detail/:id", component: TicketDetailComponent },

          { path: "ads-manager", component: AdsManagerComponent },

          { path: "startups", component: ManageStartupsComponent },
          { path: "startups/create", component: StartupsFormComponent },
          { path: "startups/edit/:id", component: StartupsFormComponent },

          { path: "founders", component: ManageFoundersComponent },
          { path: "founders/create", component: FoundersFormComponent },
          { path: "founders/edit/:id", component: FoundersFormComponent },

          { path: "news", component: ManageNewsComponent },
          { path: "news/create", component: NewsFormComponent },
          { path: "news/edit/:id", component: NewsFormComponent },

          { path: "pages", component: ManagePagesComponent },
          { path: "pages/create", component: PagesFormComponent },
          { path: "pages/edit/:id", component: PagesFormComponent },

          { path: "trustpilot", component: ManageTrustpilotComponent },
          { path: "trustpilot/create", component: TrustpilotFormComponent },
          { path: "trustpilot/edit/:id", component: TrustpilotFormComponent },

          { path: "users", component: ManageUsersComponent },
          { path: "users/create", component: UsersFormComponent },
          { path: "users/edit/:id", component: UsersFormComponent },

          { path: "", component: AdminDashboardComponent },
        ],
      },
    ],
  },

  // Default and fallback
  { path: "", redirectTo: "admin", pathMatch: "full" },
  { path: "**", component: PageNotFoundComponent },
];
